import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function ChevronRight24() {
  return /*#__PURE__*/_jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.4 18.9863L16 11.9863L9.4 4.98633",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}